import Configuration from '@/agilis/util/Configuration'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'
import { mapGetters } from 'vuex'

// Mixin providing common render utils
export default {
  name: 'LinkToMixin',

  components: {
    UnStyledLink
  },

  computed: {
    ...mapGetters({
      userId: 'userDataStore/userId',
      'applicationId': 'contextStore/applicationId',
      'workspaceId': 'contextStore/workspaceId'
    })
  },

  methods: {
    resolveLinkPlaceholder (placeholder, item) {
      if (/^\$/.test(placeholder)) {
        const prop = placeholder.slice(1)
        return item[prop]
      }
      return placeholder
    },

    linkColor (colConfig) {
      return colConfig.linkTo?.color
    },

    linkDecoration (colConfig) {
      return colConfig.linkTo?.textDecoration
    },

    linkToActive (colConfig, targetItem) {
      const linkTo = colConfig.linkTo
      let userHasPermission = false

      const trackerId = linkTo && (linkTo.trackerId ? this.resolveLinkPlaceholder(linkTo.trackerId, targetItem) : targetItem?.id)

      if (trackerId && linkTo?.trackerTypeId) {
        const linkContext = {
          applicationId: linkTo.applicationId ? this.resolveLinkPlaceholder(linkTo.applicationId, targetItem) : this.applicationId,
          mode: 'view',
          trackerId,
          trackerTypeId: this.resolveLinkPlaceholder(linkTo.trackerTypeId, targetItem),
          workspaceId: linkTo.workspaceId ? this.resolveLinkPlaceholder(linkTo.workspaceId, targetItem) : this.workspaceId
        }
        userHasPermission = Configuration.auth.userCanDo(linkContext, 'get', targetItem, this.userId)
      }

      return targetItem && linkTo && userHasPermission
    },

    linkToHref (colConfig, targetItem) {
      const linkTo = colConfig.linkTo

      if (linkTo?.trackerTypeId) {
        return this.$router.agilis.urlViewTracker({
          applicationId: linkTo.applicationId ? this.resolveLinkPlaceholder(linkTo.applicationId, targetItem) : this.applicationId,
          trackerId: linkTo.trackerId ? this.resolveLinkPlaceholder(linkTo.trackerId, targetItem) : targetItem.id,
          trackerTypeId: this.resolveLinkPlaceholder(linkTo.trackerTypeId, targetItem),
          workspaceId: linkTo.workspaceId ? this.resolveLinkPlaceholder(linkTo.workspaceId, targetItem) : this.workspaceId
        })
      }

      return null
    },

    linkToRoute (colConfig, targetItem) {
      const linkTo = colConfig.linkTo

      if (linkTo?.trackerTypeId) {
        this.$router.agilis.viewTracker({
          applicationId: linkTo.applicationId ? this.resolveLinkPlaceholder(linkTo.applicationId, targetItem) : this.applicationId,
          trackerId: linkTo.trackerId ? this.resolveLinkPlaceholder(linkTo.trackerId, targetItem) : targetItem?.id,
          trackerTypeId: this.resolveLinkPlaceholder(linkTo.trackerTypeId, targetItem),
          workspaceId: linkTo.workspaceId ? this.resolveLinkPlaceholder(linkTo.workspaceId, targetItem) : this.workspaceId
        })
      }
    },

    linkTargetItem (colId, item) {
      if (typeof item[colId] === 'object') {
        return item[colId]
      }
      return item
    }
  }
}
